const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Main/Project');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class Project extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				gravity="center_horizontal"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("Header")}
					height="99"
					width="match_parent"
					orientation="horizontal"
					padding="80,32,80,31"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Header}>
					<LinearLayout
						id={this.id("Group_5")}
						height="36"
						width="299"
						orientation="horizontal"
						style={this.style_Group_5}>
						<LinearLayout
							id={this.id("Juspay_Logo_V3")}
							height="34"
							width="152"
							orientation="horizontal"
							gravity="center"
							weight="1"
							style={this.style_Juspay_Logo_V3}>
							<ImageView
								id={this.id("Juspay_Logo_V3100000000ø")}
								height="34"
								width="match_parent"
								imageUrl="juspay_logo_v329"
								style={this.style_Juspay_Logo_V3100000000ø} />
						</LinearLayout>
						<ImageView
							id={this.id("University")}
							height="31"
							width="143"
							margin="4,5,0,0"
							imageUrl="university28"
							style={this.style_University} />
					</LinearLayout>
					<LinearLayout
						id={this.id("Space")}
						weight="1"
						style={this.style_Space} />
					<LinearLayout
						id={this.id("Group")}
						height="25"
						width="171"
						orientation="horizontal"
						margin="0,5,0,0"
						style={this.style_Group}>
						<TextView
							id={this.id("Register")}
							height="25"
							width="67"
							weight="1"
							text={this.STR.Register1}
							textSize={FontSize.A_18}
							color={FontColor.A__FF3A3A3A}
							fontStyle={Font.AVENIR_ROMAN}
							gravity="left"
							style={this.style_Register} />
						<TextView
							id={this.id("Forum")}
							height="25"
							width="53"
							margin="51,0,0,0"
							text={this.STR.Forum2}
							textSize={FontSize.A_18}
							color={FontColor.A__FF3A3A3A}
							fontStyle={Font.AVENIR_ROMAN}
							gravity="left"
							style={this.style_Forum} />
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("Group_9")}
					height="1325"
					width="660"
					orientation="vertical"
					gravity="center_horizontal"
					margin="0,40,0,0"
					style={this.style_Group_9}>
					<TextView
						id={this.id("Internship___Juspay")}
						height="64"
						width="match_parent"
						text={this.STR.Internship___Juspay29}
						textSize={FontSize.A_60}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="64px"
						gravity="left"
						style={this.style_Internship___Juspay} />
					<TextView
						id={this.id("While_learning_to_cr")}
						height="112"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.While_learning_to_cr30}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_While_learning_to_cr} />
					<TextView
						id={this.id("Project")}
						height="33"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Project31}
						textSize={FontSize.A_24}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						gravity="left"
						style={this.style_Project} />
					<TextView
						id={this.id("Overview")}
						height="25"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Overview32}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_HEAVY}
						gravity="left"
						style={this.style_Overview} />
					<TextView
						id={this.id("For_an_eager_learner")}
						height="60"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.For_an_eager_learner33}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_For_an_eager_learner} />
					<TextView
						id={this.id("The_app_will_allow_l")}
						height="90"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.The_app_will_allow_l34}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_The_app_will_allow_l} />
					<TextView
						id={this.id("App_Features")}
						height="30"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.App_Features35}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_HEAVY}
						lineHeight="28px"
						gravity="left"
						style={this.style_App_Features} />
					<TextView
						id={this.id("Register200000000ø")}
						height="30"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Register1}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="28px"
						gravity="left"
						style={this.style_Register200000000ø} />
					<LinearLayout
						id={this.id("Group_8")}
						height="90"
						width="match_parent"
						orientation="vertical"
						gravity="center_horizontal"
						margin="0,5,0,0"
						style={this.style_Group_8}>
						<LinearLayout
							id={this.id("Group300000000ø")}
							height="30"
							width="match_parent"
							orientation="horizontal"
							gravity="center_vertical"
							style={this.style_Group300000000ø}>
							<LinearLayout
								id={this.id("Bullet")}
								height="8"
								width="8"
								orientation="horizontal"
								gravity="center"
								style={this.style_Bullet}>
								<ImageView
									id={this.id("Group400000000ø")}
									height="8"
									width="8"
									imageUrl="group26"
									style={this.style_Group400000000ø} />
							</LinearLayout>
							<TextView
								id={this.id("Get_user_details_lik")}
								height="30"
								width="642"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.Get_user_details_lik36}
								textSize={FontSize.A_18}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="28px"
								gravity="left"
								style={this.style_Get_user_details_lik} />
						</LinearLayout>
						<LinearLayout
							id={this.id("Group_3")}
							height="60"
							width="match_parent"
							orientation="horizontal"
							padding="0,0,0,-1"
							style={this.style_Group_3}>
							<LinearLayout
								id={this.id("Bullet500000000ø")}
								height="8"
								width="8"
								orientation="horizontal"
								gravity="center"
								margin="0,11,0,0"
								style={this.style_Bullet500000000ø}>
								<ImageView
									id={this.id("Group600000000ø")}
									height="8"
									width="8"
									imageUrl="group27"
									style={this.style_Group600000000ø} />
							</LinearLayout>
							<TextView
								id={this.id("If_user_is_a_learner")}
								height="60"
								width="642"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.If_user_is_a_learner37}
								textSize={FontSize.A_18}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="28px"
								gravity="left"
								style={this.style_If_user_is_a_learner} />
						</LinearLayout>
					</LinearLayout>
					<TextView
						id={this.id("Explore")}
						height="25"
						width="match_parent"
						margin="0,15,0,0"
						text={this.STR.Explore38}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						gravity="left"
						style={this.style_Explore} />
					<TextView
						id={this.id("A_learner_can_explor")}
						height="60"
						width="match_parent"
						margin="0,5,0,0"
						text={this.STR.A_learner_can_explor39}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_A_learner_can_explor} />
					<TextView
						id={this.id("Learn")}
						height="25"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Learn40}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						gravity="left"
						style={this.style_Learn} />
					<TextView
						id={this.id("A_learner_can_commun")}
						height="60"
						width="match_parent"
						margin="0,5,0,0"
						text={this.STR.A_learner_can_commun41}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_A_learner_can_commun} />
					<TextView
						id={this.id("Tips")}
						height="30"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Tips42}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_HEAVY}
						lineHeight="28px"
						gravity="left"
						style={this.style_Tips} />
					<LinearLayout
						id={this.id("Group_7")}
						height="150"
						width="match_parent"
						orientation="vertical"
						gravity="center_horizontal"
						margin="0,10,0,0"
						style={this.style_Group_7}>
						<LinearLayout
							id={this.id("Group_2")}
							height="30"
							width="match_parent"
							orientation="horizontal"
							gravity="center_vertical"
							style={this.style_Group_2}>
							<LinearLayout
								id={this.id("Bullet700000000ø")}
								height="8"
								width="8"
								orientation="horizontal"
								gravity="center"
								style={this.style_Bullet700000000ø}>
								<ImageView
									id={this.id("Group800000000ø")}
									height="8"
									width="8"
									imageUrl="group22"
									style={this.style_Group800000000ø} />
							</LinearLayout>
							<TextView
								id={this.id("Use_a_hosted_server")}
								height="30"
								width="642"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.Use_a_hosted_server43}
								textSize={FontSize.A_18}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="28px"
								gravity="left"
								style={this.style_Use_a_hosted_server} />
						</LinearLayout>
						<LinearLayout
							id={this.id("Group_4")}
							height="30"
							width="match_parent"
							orientation="horizontal"
							style={this.style_Group_4}>
							<LinearLayout
								id={this.id("Bullet900000000ø")}
								height="8"
								width="8"
								orientation="horizontal"
								gravity="center"
								margin="0,11,0,0"
								style={this.style_Bullet900000000ø}>
								<ImageView
									id={this.id("Group1000000000ø")}
									height="8"
									width="8"
									imageUrl="group25"
									style={this.style_Group1000000000ø} />
							</LinearLayout>
							<TextView
								id={this.id("If_that_is_not_possi")}
								height="30"
								width="642"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.If_that_is_not_possi44}
								textSize={FontSize.A_18}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="28px"
								gravity="left"
								style={this.style_If_that_is_not_possi} />
						</LinearLayout>
						<LinearLayout
							id={this.id("Group_6")}
							height="30"
							width="match_parent"
							orientation="horizontal"
							style={this.style_Group_6}>
							<LinearLayout
								id={this.id("Bullet1100000000ø")}
								height="8"
								width="8"
								orientation="horizontal"
								gravity="center"
								margin="0,11,0,0"
								style={this.style_Bullet1100000000ø}>
								<ImageView
									id={this.id("Group1200000000ø")}
									height="8"
									width="8"
									imageUrl="group23"
									style={this.style_Group1200000000ø} />
							</LinearLayout>
							<TextView
								id={this.id("Use_websockets_for_i")}
								height="30"
								width="642"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.Use_websockets_for_i45}
								textSize={FontSize.A_18}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="28px"
								gravity="left"
								style={this.style_Use_websockets_for_i} />
						</LinearLayout>
						<LinearLayout
							id={this.id("Group_51300000000ø")}
							height="60"
							width="match_parent"
							orientation="horizontal"
							style={this.style_Group_51300000000ø}>
							<LinearLayout
								id={this.id("Bullet1400000000ø")}
								height="8"
								width="8"
								orientation="horizontal"
								gravity="center"
								margin="0,11,0,0"
								style={this.style_Bullet1400000000ø}>
								<ImageView
									id={this.id("Group1500000000ø")}
									height="8"
									width="8"
									imageUrl="group24"
									style={this.style_Group1500000000ø} />
							</LinearLayout>
							<TextView
								id={this.id("Feel_free_to_design")}
								height="60"
								width="642"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.Feel_free_to_design46}
								textSize={FontSize.A_18}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="28px"
								gravity="left"
								style={this.style_Feel_free_to_design} />
						</LinearLayout>
					</LinearLayout>
					<LinearLayout
						id={this.id("ButtonGroup")}
						height="60"
						width="match_parent"
						orientation="horizontal"
						gravity="center_vertical"
						padding="0,0,460,0"
						margin="0,50,0,0"
						cornerRadius="0"
						style={this.style_ButtonGroup}>
						<LinearLayout
							id={this.id("Space1600000000ø")}
							weight="1"
							style={this.style_Space1600000000ø} />
						<LinearLayout
							id={this.id("Button")}
							height="60"
							width="200"
							orientation="vertical"
							padding="60,14,0,13"
							background={Color.A__FFFF0000}
							cornerRadius="4"
							style={this.style_Button}>
							<TextView
								id={this.id("Submit")}
								height="33"
								width="80"
								text={this.STR.Submit47}
								textSize={FontSize.A_24}
								color={FontColor.A__FFFFFFFF}
								fontStyle={Font.AVENIR_BLACK}
								gravity="left"
								style={this.style_Submit} />
						</LinearLayout>
					</LinearLayout>
					<LinearLayout
						id={this.id("Rectangle")}
						height="90"
						width="match_parent"
						background={Color.A__FFFFFFFF}
						margin="0,21,0,0"
						cornerRadius="0"
						style={this.style_Rectangle} />
				</LinearLayout>
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = Project;



// WEBPACK FOOTER //
// ./views/Main/Project.js